export enum AuthEnvironment {
    PPE,    // Pre-Production Environment
    Prod    // Production
}

export type UIAuthProvider=(getAccessToken: ()=>Promise<any>)=>Promise<any>;

export interface IAuthenticationProvider {
    Authenticate(): void;
    GetAccessToken(resource: string): Promise<string>;
    GetAuthEnvironment(): AuthEnvironment;
    SetUIAuthProvider(uiAuthProvider: UIAuthProvider): void;
}